import { API_ROUTES } from "src/Common/ApiRoutes";
import { LoginApiModel, LoginPayload } from "src/Common/Models/Auth/LoginApiModel";
import axiosInstance from "src/utils/axios/axiosInstance";

export const LoginApi = async (creds: LoginPayload): Promise<LoginApiModel> => {
    const response = await axiosInstance.post(API_ROUTES.LOGIN, creds);
    return response.data; 
};
